module.exports = __webpack_public_path__ + "img/attachment.00a8caef.svg";